import * as React from 'react';
import { Dropdown, DropDownProps } from 'antd';

export const DropdownWhenScroll: React.FC<DropDownProps> = ((props) => {
    return (
        <Dropdown {...props} getPopupContainer={trigger => trigger.parentNode as HTMLElement}>
            {props.children}
        </Dropdown>);
});
